import WorkLog from "../../models/WorkLog";
import Position from "../../models/Position";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

interface QuickEditRowProps {
  instance: WorkLog;
  quickEditWorkLog?: WorkLog;
  isEditingRow: (instance: WorkLog) => boolean;
  handleOnQuickEditSave: (workLog: WorkLog, fromEnterKey?: boolean, dayOff?: boolean) => void;
  setQuickEditWorkLog: (workLog: WorkLog | null) => void;
  currPosition?: Position | null;
  setShouldFocus: (focus: boolean) => void;
  setFechUpdate: (fetch: boolean) => void;
}

export const QuickEditRow = ({
  instance,
  quickEditWorkLog,
  isEditingRow,
  handleOnQuickEditSave,
  setQuickEditWorkLog,
  currPosition,
  setShouldFocus,
  setFechUpdate,
}: QuickEditRowProps) => {
  const { t } = useTranslation();

  const handleEditAddClick = () => {
    setQuickEditWorkLog({
      ...instance,
      hours: currPosition ? currPosition.externalHours : 8,
      internalHours: currPosition ? currPosition.internalHours : 8,
    });
    setShouldFocus(true);
  };

  const handleOnCancel = () => {
    setQuickEditWorkLog(null);
    setFechUpdate(true);
  };

  return (
    <div>
      {isEditingRow(instance) ? (
        <>
          <Tooltip title={t("Save") as string}>
            <IconButton
              tabIndex={0}
              size="small"
              onClick={() => {
                handleOnQuickEditSave(quickEditWorkLog!);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  e.stopPropagation();
                  handleOnQuickEditSave(quickEditWorkLog!, true);
                }
              }}
            >
              <CheckIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={t("Day Off") as string}>
            <IconButton
              tabIndex={0}
              size="small"
              onClick={() => {
                handleOnQuickEditSave(quickEditWorkLog!, false, true);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  e.stopPropagation();
                  handleOnQuickEditSave(quickEditWorkLog!, true, true);
                }
              }}
            >
              <BeachAccessIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={t("Cancel") as string}>
            <IconButton size="small" tabIndex={0} onClick={handleOnCancel}>
              <ClearIcon />
            </IconButton>
          </Tooltip>
        </>
      ) : (
        <>
          {instance.externalId ? (
            <EditIcon tabIndex={0} onClick={handleEditAddClick} />
          ) : (
            <AddIcon tabIndex={0} onClick={handleEditAddClick} />
          )}
        </>
      )}
    </div>
  );
};
